<template>
    <div>
        <el-popover
            placement="top-start"
            title=""
            trigger="click"
            content="">
            <el-date-picker
                size="small"
                type="daterange"
                v-model="times"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="batchSetTime">
            </el-date-picker>
            <el-button type="text" slot="reference">批量设置产品时间</el-button>
        </el-popover>
        <el-table style="width: 100% " :data="list" class="tab-product" v-watermask>
            <el-table-column prop="name" label="产品名称"></el-table-column>
            <el-table-column prop="price" label="产品价格">
                <template slot-scope="scope">
                    <span v-if="scope">
                        <el-input  size="mini" type="number" :disabled="disableEdit || scope.row.code == 11" v-model="scope.row.price" @change="priceChange(scope.row)" placeholder="请输入价格"></el-input>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="effect_at" label="合作时间" width="300">
                <template slot-scope="scope">
                    <div v-if="scope">
                        <el-date-picker
                            size="mini"
                            type="daterange"
                            v-model="scope.row.effect_at"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            @change="timeChange($event, scope.row)" 
                            :clearable="false"
                            :disabled="scope.row.disabled || scope.row.code == 11"
                            style="width:280px;">
                        </el-date-picker>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="版本" prop="type" >
                <template slot-scope="scope">
                    <el-radio-group v-model="scope.row.type" v-if="scope.row.code == config.XWT_PRODUCT_CODE || scope.row.code == config.ZUJUAN_PRODUCT_CODE">
                        <el-radio size="mini"  :disabled="disableEdit" :label=1>标准版</el-radio>
                        <el-radio size="mini"  :disabled="disableEdit" :label=2>额度版</el-radio>
                    </el-radio-group>
                </template>
            </el-table-column>
            <el-table-column prop="refund_amount" label="退款金额" v-if="revise_type == 'refund'">
                <template slot-scope="scope">
                    <span v-if="scope">
                        <el-input  size="mini" type="number" :disabled="true" v-model="scope.row.refund_amount"></el-input>
                    </span>
                </template>
            </el-table-column>
            <el-table-column center label="操作">
                <template slot-scope="scope">
                    <div>
                        <el-button v-if="scope.row.code != 11" type="text" size="small" @click="handleDeleteProduct(scope.row.id)">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>
<script>
    import Config from "~/config/params";

    export default {
        data() {
            return {
                pickerOptions1: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                    },
                },
                list: [],
                times: [],
            }
        },
        props: {
            showProduct: {
                type: Array,
                required: true
            },
            disableEdit: {
                default: false,
                type: Boolean,
                required: false
            },
            revise_type: {
                default: '',
                type: String,
                required: false
            },
        },
        created() {
            this.list = _.clone(this.showProduct);
            this.config = Config;
            this.setDefaultSzxyData();
            // console.log('进入', this.showProduct);
        },
        methods: {
            priceChange(row){
                let old_price = (Math.round(parseFloat(row.old_price) * 100) / 100);
                let price = (Math.round(parseFloat(row.price) * 100) / 100);
                if(this.revise_type == 'refund' && price > old_price){
                    this.$message({
                        message: row.product_name + " 的价格填写错误, 退款修订只能下调产品价格",
                        type: "error"
                    });
                    row.price = row.old_price;
                    return;
                }
                console.log('priceChange:', row.price, row.old_price);
                this.handleChange();
            },

            batchSetTime(val){
                console.log('batchSetTime：', this.list);
                this.list = this.list.map(product => ({
                    ...product, // 保留原始对象的其他属性
                    start_at_fomat: val[0],
                    end_at_fomat: val[1],
                    start_at: new Date(val[0]).getTime(),
                    end_at: new Date(val[1]).getTime(),
                    effect_at: val,
                }));
                this.setDefaultSzxyData();
            },

            freshCount() {
                this.handleChange();
            },

            checkedProduct(val){
                this.list = val;
                this.setDefaultSzxyData();
            },

            handleChange(){
                // this.showProduct = this.list;
                this.$emit('change', this.list);
            },

            timeChange(val, row){
                console.log('timeChange:', val, row);
                const product = this.list.find(product => product.code == row.code);
                if (product) {
                    this.$set(product, 'start_at_fomat', val[0]);
                    this.$set(product, 'end_at_fomat', val[1]);
                    this.$set(product, 'effect_at', val);
                    this.$set(product, 'start_at', new Date(val[0] + ' 00:00:00').getTime());
                    this.$set(product, 'end_at', new Date(val[1] + ' 00:00:00').getTime());
                }
                console.log('时间更新', val);
                this.setDefaultSzxyData();
            },
            
            handleDeleteProduct(id) {
                this.$confirm('此操作是删除操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }).then(() => {
                    this.list = this.list.filter(function (item) {
                        return item.id != id;
                    });
                    this.setDefaultSzxyData();
                    this.$emit('delete', id);
                }).catch(() => {

                });
            },

            //设置数字化校园默认时间，取所有产品里面最早开始时间和最晚开始时间
            setDefaultSzxyData(){
                console.log('setDefaultSzxyData：', this.list);
                let product = null;
                this.list.forEach(item => {
                    if(!product){
                        product = item;
                    }
                    // console.log('结束时间：', product, product.end_at < item.end_at, product.end_at, item.end_at);
                    if(product.end_at < item.end_at){
                        product = item;
                    }
                });
                const product11 = this.list.find(item => item.code == 11);
                if (product11) {
                    this.$set(product11, 'start_at', product.start_at);
                    this.$set(product11, 'end_at', product.end_at);
                    this.$set(product11, 'effect_at', product.effect_at);
                    this.$set(product11, 'start_at_fomat', product.effect_at[0]);
                    this.$set(product11, 'end_at_fomat', product.effect_at[1]);
                }
                this.$emit('contractTime', product.effect_at);
                this.handleChange();
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/table.vue